export const ENV_SHORT_NAME_MAP: Record<string, string> = {
    glbl: "gbl",
    "prod-pci": "pci",
    prod: "prd",
    stage: "stg",
    dev: "dev",
    sandbox: "sdb",
};

export function businessUnitSuffix(businessUnit: string): string {
    const parts = businessUnit.split("-");
    return parts.length >= 2 && parts[1] ? parts[1] : businessUnit;
}

/**
  Builds the `jh-<env>-<suffix>-<productName>` project ID shape. Used both as
  a live preview while the form is being filled out (`ProductNameField`) and
  to reconstruct the ID from a completed workflow's memo (`useProjectRequests`).
  The real, authoritative ID is generated server-side in Go; this must stay in
  sync with it, not just with itself.
*/

export function buildProjectId(
    projectType: string,
    businessUnit: string,
    productName: string
): string {
    const shortEnv = ENV_SHORT_NAME_MAP[projectType] ?? projectType;
    const suffix = businessUnit ? businessUnitSuffix(businessUnit) : "";
    const normalizedProductName = productName.toLowerCase().replace(/\s+/g, "");

    return suffix
        ? `jh-${shortEnv}-${suffix}-${normalizedProductName}`
        : `jh-${shortEnv}-${normalizedProductName}`;
}
